module.exports = __webpack_public_path__ + "img/slide21.d56b1add.png";